import { render } from "./TableData3Show.vue?vue&type=template&id=27c854a9&scoped=true"
import script from "./TableData3Show.vue?vue&type=script&lang=js"
export * from "./TableData3Show.vue?vue&type=script&lang=js"

import "./TableData3Show.vue?vue&type=style&index=0&id=27c854a9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c854a9"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableData3Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c854a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c854a9', __exports__)) {
    api.reload('27c854a9', __exports__)
  }
  
  module.hot.accept("./TableData3Show.vue?vue&type=template&id=27c854a9&scoped=true", () => {
    api.rerender('27c854a9', render)
  })

}


export default __exports__